"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CallingOptionsOptionSetNumber;
(function (CallingOptionsOptionSetNumber) {
    CallingOptionsOptionSetNumber[CallingOptionsOptionSetNumber["NoCalling"] = 192350000] = "NoCalling";
    CallingOptionsOptionSetNumber[CallingOptionsOptionSetNumber["VideoAndVoiceCalling"] = 192350001] = "VideoAndVoiceCalling";
    CallingOptionsOptionSetNumber[CallingOptionsOptionSetNumber["VoiceOnly"] = 192350002] = "VoiceOnly";
})(CallingOptionsOptionSetNumber || (CallingOptionsOptionSetNumber = {}));
exports.default = CallingOptionsOptionSetNumber;
//# sourceMappingURL=CallingOptionsOptionSetNumber.js.map